module.exports = __webpack_public_path__ + "static/media/traffictoday.ad5f4ee8.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/traffictoday.webp
// module id = 404
// module chunks = 0